import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { PortalSettingsService } from 'src/app/core/services/portal-settings.service';
import { PortalSettings } from '../../../../pages/account/services/account.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-finalize-submited-modal',
  templateUrl: './finalize-submited-modal.component.html',
  styleUrls: ['./finalize-submited-modal.component.css'],
})
export class FinalizeSubmitedModalComponent implements OnInit {
  @Input() data: boolean;
  @Input() proxy: number;
  portalSettings: PortalSettings;
  modalText: string;

  constructor(
    portalSettingsService: PortalSettingsService,
    private ngbActiveModal: NgbActiveModal,
    private router: Router
  ) {
    this.portalSettings = portalSettingsService.getPortalSettings();
  }

  ngOnInit(): void {
    this.modalText = this.data
      ? this.portalSettings.BenefitSubmitModalText.ConfigValue
      : 'There was an error finalizing your benefit. Please contact portal administrator.';
  }
  okClicked(): void {
    if (this.proxy != null) {
      this.router.navigate(['/approval/benefitsdashboard']);
    } else {
      this.router.navigate(['/employee/benefitsenrollment']);
    }
    this.ngbActiveModal.close();
  }
}
